// extracted by css-extract-rspack-plugin
export default {"empty":"empty-hvLDsO","emptyAccount":"emptyAccount-yVGbua","emptyAccountIsCopied":"emptyAccountIsCopied-CZMXZB"};